<template>
	<v-tooltip top content-class="tooltip-content members-tooltip-data">
		<template v-slot:activator="{ on, attrs }">
			<span v-bind="attrs" v-on="on">
				<span class="ml-1 text underline"> see details </span>
			</span>
		</template>
		<div>
			<div class="box">
				<div class="member-title">Premium members</div>
				<div class="text">
					{{ premiumUserText }}<span class="pending">{{ invitedPremiumUserText }}</span>
				</div>
			</div>
			<div class="box">
				<div class="member-title">Standard members</div>
				<div class="text">
					{{ standardUserText }}<span class="pending">{{ invitedStandardUserText }}</span>
				</div>
			</div>
			<div class="box">
				<div class="member-title">Lite members</div>
				<div class="text">
					{{ liteUserText }}<span class="pending">{{ invitedLiteUserText }}</span>
				</div>
			</div>
		</div>
	</v-tooltip>
</template>

<script>
import BillingService from '@/components/Billing/billing-service';
import { BillingLevel, FeatureTypes } from '@/components/Billing/billing-types';
import { teamMembers } from '@/store/modules/account/getters';
import { useEntitlement } from '@/store/modules/billing/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'SettingsManageUsersTooltip',
	components: {},
	props: {},
	computed: {
		...mapGettersShorthand({ teamMembers, useEntitlement }),
		premiumUserText() {
			return this.activeMembersText(FeatureTypes.PremiumUsersCount);
		},
		standardUserText() {
			return this.activeMembersText(FeatureTypes.StandardUsersCount);
		},
		liteUserText() {
			return this.activeMembersText(FeatureTypes.LiteUsersCount);
		},
		invitedPremiumUserText() {
			return this.pendingMembersText(BillingLevel.PremiumMember, FeatureTypes.PremiumUsersCount);
		},
		invitedStandardUserText() {
			return this.pendingMembersText(BillingLevel.StandardMember, FeatureTypes.StandardUsersCount);
		},
		invitedLiteUserText() {
			return this.pendingMembersText(BillingLevel.LiteMember, FeatureTypes.LiteUsersCount);
		},
	},
	methods: {
		activeMembersText(feature_id) {
			return `${this.activeMembers(feature_id)}/${this.membersAllowed(feature_id)} active `;
		},
		pendingMembersText(billing_level, feature_id) {
			if (!this.useEntitlement(feature_id)?.has_access) {
				return '';
			}
			const invited = this.membersInvited(billing_level);
			return invited > 0 ? `(${invited} pending)` : '';
		},
		activeMembers(feature_id) {
			return this.useEntitlement(feature_id).entitlement.current_usage || 0;
		},
		membersInvited(billing_level) {
			return this.teamMembers.filter((member) => member.billing_level === billing_level && member.is_invitation_pending).length;
		},
		membersAllowed(feature_id) {
			if (BillingService.isEntitlementUnlimited(this.useEntitlement(feature_id))) {
				return 'unlimited';
			}
			return this.useEntitlement(feature_id).entitlement.usage_limit || 0;
		},
	},
};
</script>

<style scoped lang="scss">
.members-tooltip-data {
	opacity: 1;
	background-color: white;
	color: black;
	box-shadow: 0px 4px 4px 0px #00000040;
	padding: 12px 15px;
	border-radius: 5px;
	.box {
		width: 250px;
		padding: 3px 0px;
		.member-title {
			font-size: 12px;
			font-weight: 600;
			color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
		}
		.text {
			font-size: 14px;
			font-weight: 400;
			color: #262626;

			.pending {
				color: #262626;
				opacity: 0.5;
			}
		}
	}
}
</style>
